/**
 * Status do relatório — API serializa o nome do enum (string), não o int.
 * Ex.: "NaoIniciada" | "EmDia" | "EmAtencao" | "Atrasada" | "Concluida"
 */
export const RdoStatusEnum = {
  NaoIniciada: "NaoIniciada",
  EmDia: "EmDia",
  EmAtencao: "EmAtencao",
  Atrasada: "Atrasada",
  Concluida: "Concluida",
} as const;

export type RdoStatus = (typeof RdoStatusEnum)[keyof typeof RdoStatusEnum];

/** Aceita string da API ou int legado (1–5). */
export function normalizeRdoStatus(value: unknown): RdoStatus {
  if (typeof value === "string") {
    const match = (Object.values(RdoStatusEnum) as string[]).find(
      (name) => name.toLowerCase() === value.toLowerCase()
    );
    if (match) return match as RdoStatus;
  }

  if (typeof value === "number") {
    const byNumber: Record<number, RdoStatus> = {
      1: RdoStatusEnum.NaoIniciada,
      2: RdoStatusEnum.EmDia,
      3: RdoStatusEnum.EmAtencao,
      4: RdoStatusEnum.Atrasada,
      5: RdoStatusEnum.Concluida,
    };
    if (byNumber[value]) return byNumber[value];
  }

  return RdoStatusEnum.NaoIniciada;
}

export type RdoMetricasApi = {
  areaPrevista: number | null;
  areaRealizada: number | null;
  areaARealizar: number | null;
  percentualExecucao: number | null;
  metaDiaria: number | null;
  ritmoDiario: number | null;
  metaDiariaAjustada?: number | null;
  dataInicial?: string | null;
  projecaoTermino?: string | null;
  status: RdoStatus | string | number;
};

export type RdoDetalhamentoApi = RdoMetricasApi & {
  sequencia: number;
  descricao: string;
  operacaoCalendarizada?: boolean;
};

export type RdoOperacaoClasseApi = RdoMetricasApi & {
  operacaoClasseId: string;
  operacaoClasse: string;
  operacaoCalendarizada: boolean;
  detalhamentos: RdoDetalhamentoApi[] | null;
};

export type RdoPeriodoApi = {
  safraPeriodoId: string;
  safraPeriodo: string;
  ocupacaoId: string;
  ocupacao: string;
  operacaoClasses: RdoOperacaoClasseApi[];
};

export type RdoOperacoesResponse = RdoPeriodoApi[];

/** Row view-model for Antd Table (parent + children). */
export type RdoTableRow = {
  key: string;
  isParent: boolean;
  operacaoClasseId: string;
  operacaoCalendarizada: boolean;
  nome: string;
  /** Nome da classe (pai); em filho ≠ nome (Passada/Janela N). */
  operacaoNome: string;
  sequencia: number | null;
  areaPrevista: number | null;
  areaRealizada: number | null;
  areaARealizar: number | null;
  percentualExecucao: number | null;
  metaDiaria: number | null;
  ritmoDiario: number | null;
  metaDiariaAjustada: number | null;
  dataInicial: string | null;
  projecaoTermino: string | null;
  status: RdoStatus;
  /** Filhos do drilldown; exibidos como linhas irmãs ao expandir (Opção A). */
  detalhamentos?: RdoTableRow[];
};

export type RdoPeriodoSectionVm = {
  safraPeriodoId: string;
  titulo: string;
  ocupacao: string;
  rows: RdoTableRow[];
};
